module.exports = __webpack_public_path__ + "img/auto-block.e2f69efc.png";